import {
  UserAddress,
  UserCard,
  HardwareSubscription,
} from "@providers/profile/ProfileProvider.model";
import { StateSchema } from "../address/Address.model";
import { MembershipDisclaimers } from "@models/user-account-globals";

export const dateFormat = "MMMM dd, yyyy";

export interface SubscriptionProps {
  isDigital: boolean;
  states: Array<StateSchema>;
  digitalDisclaimers?: MembershipDisclaimers;
}

export interface SubscriptionInfoProps {
  isDigital: boolean;
  digitalDisclaimers?: MembershipDisclaimers;
  subscription: HardwareSubscription;
  dispatchBilling: React.Dispatch<React.SetStateAction<BillingState>>;
}

export interface SubscriptionInactiveProps {
  subscription: HardwareSubscription;
  dispatchBilling: React.Dispatch<React.SetStateAction<BillingState>>;
}

export interface SubscriptionDetailProps {
  subscription: HardwareSubscription;
  email?: string;
}

export const initialBillingState = {
  loading: true,
  subscription: null as HardwareSubscription,
  address: null as UserAddress,
  card: null as UserCard,
};

export interface BillingState {
  loading: boolean;
  subscription: HardwareSubscription;
  address: UserAddress;
  card: UserCard;
}
